import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DebitAccountBalanceResponse } from '../../../features/fundManagement/contributor-account-details/contributor-account-detail.model';
import { SKIP_LOADING } from '../../interceptors/http-loading.interceptor';

@Injectable({
  providedIn: 'root',
})
export class ContributorAccountService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}`;

  constructor(private http: HttpClient) {}

  getDebitAccountBalance(): Observable<DebitAccountBalanceResponse> {
    return this.http.get<DebitAccountBalanceResponse>(
      `${this.apiUrl}/PayAnyone/debit-account-balance`,
      { context: new HttpContext().set(SKIP_LOADING, true) }
    );
  }
}
